import { Language } from 'translations/Language'
import { LightroomGuideContent } from './LightroomGuideContent'
import { de } from './de'
import { en } from './en'
import { fr } from './fr'

export * from './LightroomGuideContent'

/** Guide copy for a language. The guide exists in EN / FR / DE; any other language reads EN */
export const getLightroomGuideContent = (language: Language): LightroomGuideContent => {
  switch (language) {
    case Language.FR:
      return fr
    case Language.DE:
      return de
    default:
      return en
  }
}
